const CHANGE_SOS_NOTIFICATION = 'CHANGE_SOS_NOTIFICATION';

export const changeSOSNotification = notification => ({
    type: CHANGE_SOS_NOTIFICATION,
    payload: notification,
});

export default (previousState = 0, { type, payload }) => {
    if (type === CHANGE_SOS_NOTIFICATION) {
        return payload;
    }
    return previousState;
};



// WEBPACK FOOTER //
// ./src/reducers/sosNotiReducer.js